import { JSX } from 'react'

import { IconProps } from '../../icon'

const MobileMenu: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24 19C21.5056 19 19.4872 21.0185 19.4872 23.5128C19.4872 26.0072 21.5056 28.0256 24 28.0256C26.4944 28.0256 28.5128 26.0072 28.5128 23.5128C28.5128 21.0185 26.4944 19 24 19ZM24 25.5641C22.8677 25.5641 21.9487 24.6451 21.9487 23.5128C21.9487 22.3805 22.8677 21.4615 24 21.4615C25.1323 21.4615 26.0513 22.3805 26.0513 23.5128C26.0513 24.6451 25.1323 25.5641 24 25.5641Z'
      fill='black'
    />
    <path
      d='M35.4872 19C32.9928 19 30.9744 21.0185 30.9744 23.5128C30.9744 26.0072 32.9928 28.0256 35.4872 28.0256C37.9815 28.0256 40 26.0072 40 23.5128C40 21.0185 37.9815 19 35.4872 19ZM35.4872 25.5641C34.3549 25.5641 33.4359 24.6451 33.4359 23.5128C33.4359 22.3805 34.3549 21.4615 35.4872 21.4615C36.6195 21.4615 37.5385 22.3805 37.5385 23.5128C37.5385 24.6451 36.6195 25.5641 35.4872 25.5641Z'
      fill='black'
    />
    <path
      d='M12.5128 19C10.0185 19 8 21.0185 8 23.5128C8 26.0072 10.0185 28.0256 12.5128 28.0256C15.0072 28.0256 17.0256 26.0072 17.0256 23.5128C17.0256 21.0185 15.0072 19 12.5128 19ZM12.5128 25.5641C11.3805 25.5641 10.4615 24.6451 10.4615 23.5128C10.4615 22.3805 11.3805 21.4615 12.5128 21.4615C13.6451 21.4615 14.5641 22.3805 14.5641 23.5128C14.5641 24.6451 13.6451 25.5641 12.5128 25.5641Z'
      fill='black'
    />
  </svg>
)

export default MobileMenu
